import add from "ramda/src/add";
import memoizeWith from "ramda/src/memoizeWith";
import pipe from "ramda/src/pipe";
import calculateTotalExteriorAreaFlow from "./areaLists/exteriorAreaList";
import {
  calculateTotalBathroomAreaFlow,
  calculateTotalCeilingAreaFlow,
  calculateTotalInteriorWallAreaFlow,
  calculateTotalTrimAreaFlow,
} from "./areaLists/interiorAreaList";
import {
  applyTopCoatMultiplier,
  findRecommendedQuantityForExteriorArea,
  findRecommendedQuantityForInteriorArea,
} from "./coverage/paint";

const areasHashFn = (areas) => JSON.stringify(areas);

export const calculateRecommendedExteriorWallPaint = memoizeWith(
  areasHashFn,
  (areas) =>
    pipe(
      calculateTotalExteriorAreaFlow,
      applyTopCoatMultiplier,
      findRecommendedQuantityForExteriorArea
    )(areas)
);

export const calculateRecommendedExteriorPrimer = memoizeWith(
  areasHashFn,
  (areas) =>
    pipe(
      calculateTotalExteriorAreaFlow,
      findRecommendedQuantityForExteriorArea
    )(areas)
);

export const calculateTotalRecommendedExteriorPaint = (areas, isNewJob) => {
  return isNewJob
    ? calculateRecommendedExteriorPrimer(areas) +
        calculateRecommendedExteriorWallPaint(areas)
    : calculateRecommendedExteriorWallPaint(areas);
};

export const calculateRecommendedInteriorWallPaint = memoizeWith(
  areasHashFn,
  (areas) =>
    pipe(
      calculateTotalInteriorWallAreaFlow,
      applyTopCoatMultiplier,
      findRecommendedQuantityForInteriorArea
    )(areas)
);

export const calculateRecommendedInteriorPrimer = memoizeWith(
  areasHashFn,
  (areas) =>
    pipe(
      calculateTotalInteriorWallAreaFlow,
      findRecommendedQuantityForInteriorArea
    )(areas)
);

export const calculateRecommendedInteriorCeilingPaint = memoizeWith(
  areasHashFn,
  (areas) =>
    pipe(
      calculateTotalCeilingAreaFlow,
      applyTopCoatMultiplier,
      findRecommendedQuantityForInteriorArea
    )(areas)
);

export const calculateRecommendedEnamelPaint = memoizeWith(
  areasHashFn,
  (areas) => {
    return findRecommendedQuantityForInteriorArea(
      add(
        calculateTotalBathroomAreaFlow(areas),
        applyTopCoatMultiplier(calculateTotalTrimAreaFlow(areas))
      )
    );
  }
);

export const calculateTotalRecommendedInteriorPaint = (areas, isNewJob) => {
  const totalPaint =
    calculateRecommendedInteriorWallPaint(areas) +
    calculateRecommendedInteriorCeilingPaint(areas) +
    calculateRecommendedEnamelPaint(areas);
  return isNewJob
    ? totalPaint + calculateRecommendedInteriorPrimer(areas)
    : totalPaint;
};
